// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import LockIcon from "@mui/icons-material/Lock";

// MISC
import { COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const DoorDetailsContainer = styled.div`
  @media (max-width: 1300px) {
    height: auto;
    max-height: 90vh;
    width: 90vw;
    max-width: 760px;
    border-radius: 20px;
    background-color: ${COLORS.primaryWhite};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;   
    justify-content: space-between;
    align-items: center;
    outline: none;
    padding: 60px 40px;
    overflow-y: auto;
  }
  
  @media (${WIDTH.tabletWidth}) {
    width: 95vw;
    max-width: 600px;
    padding: 40px 24px;
    border-radius: 16px;
    max-height: 85vh;
  }
  
  @media (max-width: 768px) {
    width: 95vw;
    max-width: 500px;
    padding: 30px 20px;
    border-radius: 12px;
    max-height: 80vh;
  }
  
  @media (max-width: 480px) {
    width: 95vw;
    max-width: 400px;
    padding: 24px 16px;
    border-radius: 10px;
    max-height: 75vh;
  }
  
  @media (max-width: 360px) {
    width: 95vw;
    padding: 20px 12px;
    border-radius: 8px;
    max-height: 70vh;
  }
`;
export const CloseIconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;
export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  
  @media (${WIDTH.tabletWidth}) {
    margin-bottom: 16px;
  }
  @media (max-width: 480px) {
    margin-bottom: 12px;
  }
`;

export const Title = styled.div(
  ({ color }) => css`
    font-size: 30px;
    font-family: ${FONTS.newsharp};
    color: ${color ? color : COLORS.cornflowerBlue};
    font-weight: bold;
    text-align: center;
    
    @media (${WIDTH.tabletWidth}) {
      font-size: 24px;
    }
    @media (max-width: 768px) {
      font-size: 20px;
    }
    @media (max-width: 480px) {
      font-size: 18px;
    }
    @media (max-width: 360px) {
      font-size: 16px;
    }
  `
);

export const TitleContainer = styled.div(
  ({ color }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${color ? color : COLORS.cornflowerBlue};
  `
);

export const LockerIcon = styled(LockIcon)(
  ({ color }) => css`
    && {
      margin-right: 10px;
      color: ${color ? color : COLORS.cornflowerBlue};
    }
    &.MuiSvgIcon-root {
      height: 33px;
    }
  `
);

export const Status = styled.text(
  ({ color }) => css`
    font-size: 22px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.rainbowIndigo};
    font-weight: 600;
    text-align: center;
    
    @media (${WIDTH.tabletWidth}) {
      font-size: 18px;
    }
    @media (max-width: 768px) {
      font-size: 16px;
    }
    @media (max-width: 480px) {
      font-size: 14px;
    }
    @media (max-width: 360px) {
      font-size: 13px;
    }
  `
);

export const EquipmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  margin: 16px 0;
  
  @media (${WIDTH.tabletWidth}) {
    margin: 12px 0;
  }
  @media (max-width: 480px) {
    margin: 8px 0;
  }
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 26px;
`;

export const Subtitle = styled.text`
  font-size: 20px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
  width: 200px;
`;

export const EquipmentContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 25px;
  width: 100%;
  max-width: 410px;
  
  @media (${WIDTH.tabletWidth}) {
    max-width: 100%;
    flex-wrap: wrap;
    gap: 8px;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const EquipmentDescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const EquipmentName = styled.text`
  font-size: 16px;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
  margin-right: 20px;
`;

export const EquipmentStatus = styled.text(
  ({ color }) => css`
    font-size: 14px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.primaryGreen};
    font-weight: 600;
  `
);

export const Bar = styled.div`
  height: 2px;
  background-color: ${COLORS.backgroundColor};
  margin: 10px 0;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  gap: 16px;
  
  @media (${WIDTH.tabletWidth}) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  // align-items: center;
  // width: 100%;
`;

export const ButtonContainer = styled(Button)(
  ({ orangeColor }) => css`
    && {
      padding: 8px 16px;
      text-align: center;
      font-size: 14px;
      font-family: ${FONTS.newsharp};
      font-weight: bold;
      text-transform: none;
      letter-spacing: 1.4px;
      background: white;
      border-radius: 5px;
      color: ${orangeColor ? orangeColor : COLORS.rainbowIndigo};
      border-color: ${orangeColor
      ? orangeColor
      : COLORS.rainbowIndigo} !important;
      border-bottom-color: ${orangeColor
      ? orangeColor
      : COLORS.rainbowIndigo} !important;
      min-width: 120px;
      
      @media (${WIDTH.tabletWidth}) {
        padding: 6px 12px;
        font-size: 13px;
        min-width: 100px;
      }
      @media (max-width: 768px) {
        padding: 6px 10px;
        font-size: 12px;
        min-width: 90px;
      }
      @media (max-width: 480px) {
        padding: 8px 12px;
        font-size: 12px;
        min-width: 100%;
        margin-bottom: 4px;
      }
    }
  `
);

export const ActionIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 40px;
  cursor: pointer;
`;
